import { useContext } from 'react';
import { ApolloError, useQuery } from '@apollo/client';
import { useAuth } from '@providers/AuthProvider';
import authenticatedMemberDefaultPharmacy from '@graphql/queries/authenticatedMemberDefaultPharmacy.query.gql';
import GraphQLv2Context from '@providers/GraphQLv2ContextProvider';

export interface IMemberDefaultPharmacy {
	defaultMedicationDeliveryMethod: string;
	defaultPharmacy: {
		id: string;
		name: string;
		address: string;
		city: string;
		zip: string;
	};
	b2bCustomer?: {
		id: string;
		name: string;
	};
	email: string;
}

interface IAuthenticatedMemberDefaultPharmacy {
	authenticatedMember: IMemberDefaultPharmacy;
}

type UseMemberDefaultPharmacy = () => {
	loading: boolean;
	data?: IMemberDefaultPharmacy;
	error?: ApolloError;
};

const UseMemberDefaultPharmacy: UseMemberDefaultPharmacy = () => {
	const { loggedIn } = useAuth();
	const { client: graphQLv2Client } = useContext(GraphQLv2Context);
	const { loading, error, data } = useQuery<IAuthenticatedMemberDefaultPharmacy>(
		authenticatedMemberDefaultPharmacy,
		{
			client: graphQLv2Client,
			skip: !loggedIn,
		}
	);
	return {
		loading,
		data: loading ? undefined : data?.authenticatedMember,
		error,
	};
};

export default UseMemberDefaultPharmacy;
